import GeoJSON from 'geojson'

import { Navaid } from '@/domain/models/Waypoint/Navaid'

import { NavaidIconId } from './icons'
import { formatNavaidFrequencyValue, getNavaidLabelPriority, mapNavaidTypeToIconSlug } from './navaidFormatters'

export function makeGeoJsonNavaidFeatureCollection(
  navaids: Navaid[],
  selectedId?: string
): GeoJSON.FeatureCollection<GeoJSON.Point> {
  const features: GeoJSON.Feature<GeoJSON.Point>[] = navaids.map((navaid) => {
    const id = navaid.id.toString()
    const type = navaid.type
    const slug = mapNavaidTypeToIconSlug(type)
    // Dois estados: o navaid clicado usa a variante "-active"; todos os demais (e o caso sem
    // seleção) usam o ícone padrão.
    const iconName: NavaidIconId = selectedId && id === selectedId ? (`${slug}-active` as NavaidIconId) : slug
    const label = `${navaid.code} ${formatNavaidFrequencyValue(navaid.frequency, type)}`
    const sortKey = getNavaidLabelPriority(type)

    return {
      type: 'Feature',
      id,
      geometry: {
        type: 'Point',
        coordinates: navaid.coordinates.toArray()
      },
      properties: {
        id,
        code: navaid.code,
        name: navaid.name,
        frequency: navaid.frequency,
        type,
        iconName,
        label,
        sortKey
      }
    }
  })

  return {
    type: 'FeatureCollection',
    features
  }
}
